import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { createFeeSchedule } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useCreateFeeScheduleQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.CreateFeeSchedule], createFeeSchedule, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerDashboard])
        toast.success(AppNotification.CreateFeeScheduleSuccess)
      } else {
        toast.error(`${AppNotification.CreateFeeScheduleFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.CreateFeeScheduleFailure)
    }
  })
}
